import React from 'react';
import type { DefaultOptionType } from 'antd/es/select';
import type { IStateSelectOption } from '@/constants/Order';
import { STATE_SELECT_OPTIONS_WITH_FULL_NAMES } from '@/constants/Order';

interface IStateSelectAntdOption extends DefaultOptionType {
  abbreviation: string;
  fullName: string;
}

export const renderStateSelectOptionLabel = (state: IStateSelectOption): React.ReactNode => (
  <div className="state-select-option">
    <span className="state-select-option__abbreviation">{state.label}</span>
    <span className="state-select-option__full-name">{state.fullName}</span>
  </div>
);

export const buildStateSelectAntdOptions = (): IStateSelectAntdOption[] =>
  STATE_SELECT_OPTIONS_WITH_FULL_NAMES.map((state) => ({
    value: state.value,
    label: renderStateSelectOptionLabel(state),
    abbreviation: state.label,
    fullName: state.fullName,
  }));

export const filterStateSelectOption = (input: string, option?: DefaultOptionType): boolean => {
  const normalizedInput = input.trim().toLowerCase();

  if (!normalizedInput) {
    return true;
  }

  const stateOption = option as IStateSelectAntdOption | undefined;
  const abbreviation = String(stateOption?.abbreviation ?? stateOption?.value ?? '').toLowerCase();
  const fullName = String(stateOption?.fullName ?? '').toLowerCase();

  return abbreviation.includes(normalizedInput) || fullName.includes(normalizedInput);
};

export const getStateSelectPlaceholder = (
  selectedStateValue: string | undefined,
  isDropdownOpen: boolean,
  stateLabel: string,
  searchPlaceholder: string
): string => {
  if (selectedStateValue) {
    return stateLabel;
  }

  if (isDropdownOpen) {
    return searchPlaceholder;
  }

  return stateLabel;
};
